import { createContext, useContext, useState } from 'react';

type GraphContext = [any, (network: any) => void];
export const GraphNetworkContext = createContext([
  undefined,
  () => ({}),
] as GraphContext);

export const useNetworkContextState = () => {
  const [network, setNetwork] = useState<unknown | undefined>();
  return [network, setNetwork] as GraphContext;
};

export const useGraphNetwork = () => {
  return useContext(GraphNetworkContext);
};
